/**
 * A HOC wrapping Material UIs Input Form Control with Label Component.
 * Used to unify the styles across all of our select inputs.
 */
import { get, omit } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import {
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
} from '@mui/material';
import style from '../../VendorAttribution/VendorAttribution.module.css';

import { ReactComponent as Close } from '../../../Assets/icons/close.svg';

const styles = (theme) => ({
  root: {
    marginRight: '10px',
  },
  label: {
    color: get(theme, 'palette.primary.main'),
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    lineHeight: '22pxs',
    textTransform: 'uppercase',
  },
  field: {
    '&::placeholder': {
      fontWeight: 'bold',
    },
    '&:selected': {
      backgroundColor: 'white',
      fontWeight: 'bold',
    },
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    color: 'white',
    backgroundColor: get(theme, 'palette.primary.main'),
  },
  deleteIcon: {
    fill: 'white !important',
  },
  helperText: {
    marginLeft: 'unset !important',
  },
});

const SelectInput = withStyles((props) => {
  const {
    classes,
    label,
    id,
    options,
    noDefault,
    multiSelect,
    name,
    onDelete,
    error,
  } = props;

  return (
    <FormControl
      variant="standard"
      className={classes.root}
      required={props.required}
      fullWidth={props.fullWidth}
      error={!!props.error}
    >
      <InputLabel className={classes.label} htmlFor={id}>
        {label}
      </InputLabel>
      <Select
        variant="standard"
        className={classes.field}
        renderValue={(selected) =>
          !multiSelect ? null : (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  className={classes.chip}
                  onDelete={() => onDelete(name, value)}
                  deleteIcon={<Close className={style.icon} />}
                />
              ))}
            </div>
          )
        }
        {...omit(
          props,
          'label',
          'classes',
          'required',
          'fullWidth',
          'error',
          'noDefault',
          'multiSelect',
          'onDelete',
          'options',
        )}
      >
        {!noDefault && <option value="" aria-label="None" />}
        {!multiSelect &&
          options.map((c) => (
            <option value={c.value} key={c.value}>
              {c.text}
            </option>
          ))}
        {multiSelect && options}
      </Select>
      {error ? (
        <FormHelperText className={classes.helperText} id="select-helper-text">
          {error}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}, styles);

export default SelectInput;
